var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { addMarkers, setDefaultStyle, smoothCornersIndividual } from "apparatus/draw";
import { clamp, P, Pivot, R, Segments, SharedColors } from "apparatus/library/common";
import { Caps } from "apparatus/library/shared/cap";
import { Group, Path, Shape } from "paper";
import { staticImplements } from "types";
let GlassReagentBottle = class GlassReagentBottle {
    render(appearance) {
        const height = appearance.size;
        const diameter = Math.max(appearance.size * 0.4, 32);
        const neckDiameter = clamp(diameter * 0.42, 20, 40);
        const neckHeight = 15;
        const bodyStartY = neckHeight + (diameter - neckDiameter) * 0.5;
        const bottle = new Path(Segments([[neckDiameter / 2, 0]], [[neckDiameter / 2, neckHeight], , [0, 5]], [[diameter / 2, bodyStartY], [0, -5]], [[diameter / 2, height]])).mirrorX();
        smoothCornersIndividual(bottle, { 3: 8, 4: 8 });
        const liquidMask = bottle.clone();
        setDefaultStyle(bottle);
        const undercap = Shape.Rectangle(R(0, 12, neckDiameter + 4, 3, Pivot.CENTER), 2.0)
            .withFill("#ffffff80")
            .withStroke("thinner", SharedColors.stroke);
        const graphic = new Group([bottle, undercap]);
        if (appearance.cap) {
            const cap = Caps.createCap({ radius: neckDiameter / 2, appearance }).withPosition({ x: 0, y: 6 });
            graphic.addChild(cap);
        }
        addMarkers(graphic, P(diameter / 2 - 8, height), bodyStartY, P(0, -10));
        return {
            graphic,
            liquidMask,
            hitShape: graphic.rectHitShape(),
            pivot: bottle.bounds.center,
            snapping: bottle.placeable(),
            liquidMaskOpening: appearance.cap
                ? undefined
                : { start: P(-neckDiameter / 2, 0), end: P(neckDiameter / 2, 0) }
        };
    }
};
GlassReagentBottle.properties = {
    label: "Glass Reagent Bottle",
    canContainLiquids: true,
    pourable: true,
    defaultAppearance: Object.assign({ size: 100, cap: true }, Caps.defaultAppearance),
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 50, max: 200,
        },
        { spec: "checkbox", key: "cap", label: "Show cap" },
        ...Caps.specs
    ],
};
GlassReagentBottle = __decorate([
    staticImplements()
], GlassReagentBottle);
export { GlassReagentBottle };
